const SELECTABLE_EQUIPMENT_RESTRICTION =
  "status:'ACTIVE' AND entry_type:'STANDALONE-EQUIPMENT'";

type SearchOptions = {
  searchValue?: string;
  [key: string]: unknown;
};

/**
 * Keeps log creation eligibility separate from user-controlled grid filters.
 * This restriction is therefore reapplied after search, filter and reset actions.
 */
export const withSelectableEquipmentRestriction = <T extends SearchOptions>(
  options: T
): T & { searchValue: string } => ({
  ...options,
  searchValue: options.searchValue
    ? `(${SELECTABLE_EQUIPMENT_RESTRICTION}) AND (${options.searchValue})`
    : SELECTABLE_EQUIPMENT_RESTRICTION
});

export { SELECTABLE_EQUIPMENT_RESTRICTION };
